import { Moment } from 'moment'

export const formatDate = (date: Moment): string => {
  return date.format('YYYY年MM月DD日')
}

export const formatDateTime = (date: Moment): string => {
  return date.format('YYYY年MM月DD日 HH時mm分')
}
